// extracted by mini-css-extract-plugin
export default {"accordionButton":"_5kaJVWfIWknXdHTorHvG4R","accordionButtonIcon":"_1qpCEAdceKDVK8WufRMM1p"};